import {
  Button,
  Card,
  Center,
  Divider,
  Group,
  Loader,
  Text,
  Title,
} from "@mantine/core";
import { openModal } from "@mantine/modals";
import { useNavigate } from "react-router-dom";
import {
  getApiCallGetCallListUser, getApiOrganizationGetOrganizations,
  getGetApiCallGetCallListUserKey,
  postApiCallUpsertCallSubmission,
  useGetApiCallGetCallListUser,
  useGetApiOrganizationGetOrganizations,
} from "../../api/endpoints";
import RegisterOrganization from "../../components/forms/RegisterOrganization";
import Loading from "../../components/Loading";
import useSelectedOrganizationId from "../../hooks/useSelectedOrganizationId";
import { useTranslation } from "react-i18next";
import { mutate } from "swr";
import { useStore } from "zustand";
import { sidebarStore } from "../../components/Layout";
import { useConfig } from "../../hooks/useConfig";
import AnswerPdf from "../admin/AnswerPdf";
import { castToDate, castToUnixTimestamp } from "../admin/castToDate";
import { checkToken, useAuth } from "../../auth/AuthContext";
import useApi from "../../utils/useApi";
import {CallResponse, OrganizationDto} from "../../api/model";
import {useEffect} from "react";
function downloadFile(url: string, filename: string) {
  fetch(url).then((response) => {
    response.blob().then((blob) => {
      const fileURL = window.URL.createObjectURL(blob);
      let alink = document.createElement("a");
      alink.href = fileURL;
      alink.download = filename;
      alink.click();
    });
  });
}

function isClosed(call: CallResponse) {
  var date = Date.now();
  var dateClosing = castToUnixTimestamp(call.closingAt)!;
  var dateOpening = castToUnixTimestamp(call.openingAt)!;
  
  return date > dateClosing || date < dateOpening;
}

function hasStartedSubmission(call: CallResponse) {
  return call.submissionId != "00000000-0000-0000-0000-000000000000"
}

function isSubmitted(call: CallResponse) {
  return call.submissionId != "00000000-0000-0000-0000-000000000000" && call.submissionClosed;
}

function CallList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const { data: calls, error, isLoading } = useGetApiCallGetCallListUser();
  const [selectedOrgId, setSelectedOrgId] = useSelectedOrganizationId();
  const {
    data: calls,
    setData: setCalls,
    loading: isLoading,
    setLoading: setIsLoading,
    error: error,
    setError: setError,
  } = useApi<CallResponse[]>(() => {
        // Se selectedOrgId è undefined, aspettiamo che venga impostato
        console.log("useApi getApiCallGetCallListUser",selectedOrgId)
        return getApiCallGetCallListUser();
      }
      , [selectedOrgId], selectedOrgId !== undefined);


  const {
    data: orgs,
    setData: setOrgs,
    loading: isLoadingOrgs,
    setLoading: setIsLoadingOrgs,
    error: errorOrgs,
    setError: setErrorOrgs,
  } = useApi<OrganizationDto[]>(() => getApiOrganizationGetOrganizations(), []);
  
  
  // const { data: orgs } = useGetApiOrganizationGetOrganizations();
  
  
  // const [selectedOrganizationId, setSelectedOrganizationId] =
  //   useSelectedOrganizationId();
  const auth = useAuth();

  const isAuthenticated =
    // !!auth.isAuthenticated &&
    checkToken(auth.access_token!) &&
    !!auth.access_token &&
    auth.access_token !== "null" &&
    auth.access_token !== "" &&
    auth.user;

  const config = useConfig();
  const setSidebarOpen = useStore(
    sidebarStore,
    (state) => state.setSidebarOpen
  );
  // setSidebarOpen(true);
  async function handlePbi(reportId: string, workspaceId: string) {
    if (selectedOrgId) {
      navigate(
        `/powerbi-report-rls/${workspaceId}/${reportId}/${selectedOrgId}`
      );
    }
  }

  async function handleSubmission(callId: string, closed: boolean = false, submissionId: string | null | undefined) {
    console.log("handleSubmission", callId);
    if (!selectedOrgId && orgs && orgs?.length > 0) {
      const firstOrg =
          Array.isArray(orgs) && orgs.length && typeof orgs[0] !== "undefined"
              ? orgs[0]
              : undefined;
      if (firstOrg) {
        setSelectedOrgId(firstOrg.id!);
      }
    } else if(!selectedOrgId) {
      openModal({
        title: t("pages.calls.register-organization"),
        children: <RegisterOrganization></RegisterOrganization>,
      });
    }
    if (selectedOrgId) {
      if(!closed){
        const submission = await postApiCallUpsertCallSubmission({ callId });
        navigate(
          `/call/${submission.id}${submission.closed ? "/?readonly=true" : ""}`
        );
      }else if(submissionId != null && submissionId != "00000000-0000-0000-0000-000000000000"){
        navigate(
          `/call/${submissionId}/?readonly=true`
        );
        
      }
    } 
  }
  if (error) {
    console.log("Invalid response or error", error);
    navigate(`/`);
    return (
      <Center style={{ marginTop: "25%" }}>
        <Loader />
      </Center>
    );
  }

  if (!calls || isLoading) {
    return (
      <Center style={{ marginTop: "25%" }}>
        <Loader />
      </Center>
    );
  }

  if (!Array.isArray(calls)) {
    console.log("Invalid calls", calls);
    navigate(`/`);
    return (
      <Center style={{ marginTop: "25%" }}>
        <Loader />
      </Center>
    );
  }

  if (!isAuthenticated && !auth.isLoading) {
    navigate(`/`);
  }
  console.log("calls", calls)
  return calls && Array.isArray(calls) ? (
    <>
      <Title order={1}>
        {config.listName ?? t("pages.calls.list-open-rounds")}
      </Title>

      <Divider my={25}></Divider>
      {calls
        ?.sort((a, b) => (a.name! > b.name! ? 1 : -1))
        .filter((call) => call.name != "" && call.name != null).filter((call) => !isClosed(call))
        .map((call) => (
          <Card key={call.id} shadow="sm" p="md" radius="md" mb="md" withBorder>
            <Group position="apart" mb="xs">
              <Text size="lg">{call.name}</Text>

              <Text weight={400} color="dimmed">
                {t("pages.calls.status") + " "}
                {call.closingAt &&
                  (Date.now() < castToUnixTimestamp(call.closingAt)! &&
                    Date.now() > castToUnixTimestamp(call.openingAt)!
                    ? t("pages.calls.open")
                    : t("pages.calls.close"))}
              </Text>
            </Group>

            <div dangerouslySetInnerHTML={{ __html: call.description! }}></div>

            <Divider mt="lg"></Divider>

            <Group position="right" mb="xs">
              <Button
                variant="light"
                color={call.submissionClosed ? "green" : "blue"}
                mt="sm"
                radius="sm"
                style={{ float: "right" }}
                onClick={async () => await handleSubmission(call.id!, isClosed(call), call.submissionId)}
                disabled={
                    !selectedOrgId ||
                    (isClosed(call))
                }
              >
                {
                  isSubmitted(call) && !isClosed(call)
                    ? t("pages.calls.closed")
                    : isClosed(call)
                        ? t("pages.calls.close")
                        : hasStartedSubmission(call)
                            ? t("pages.calls.resume")
                            : t("pages.calls.submit")
                }
                {/*{Date.now() < castToUnixTimestamp(call.closingAt)! &&*/}
                {/*  Date.now() > castToUnixTimestamp(call.openingAt)!*/}
                {/*  ? call.submissionId != "00000000-0000-0000-0000-000000000000"*/}
                {/*    ? call.submissionClosed*/}
                {/*      ? t("pages.calls.closed")*/}
                {/*      : call.submissionId !=*/}
                {/*        "00000000-0000-0000-0000-000000000000"*/}
                {/*        ? t("pages.calls.resume")*/}
                {/*        : t("pages.calls.submit")*/}
                {/*    : t("pages.calls.submit")*/}
                {/*  : t("pages.calls.close")}*/}
              </Button>
            </Group>
            {Date.now() > castToUnixTimestamp(call.openingAt!)! &&
              isSubmitted(call) &&
              call.userPowerBIReportID &&
              call.userPowerBIWorkspaceID ? (
              <Group position="right" mb="xs">
                <Button
                  variant="light"
                  color={"blue"}
                  mt="sm"
                  radius="sm"
                  style={{ float: "right" }}
                  disabled={!selectedOrgId}
                  onClick={async () =>
                    await handlePbi(
                      call.userPowerBIReportID!,
                      call.userPowerBIWorkspaceID!
                    )
                  }
                >
                  {t("pages.calls.viewreport")}
                </Button>
              </Group>
            ) : (
              <></>
            )}
            {Date.now() > castToUnixTimestamp(call.openingAt!)! &&
            isSubmitted(call) &&
              call.customFile ? (
              <Group position="right" mb="xs">
                <Button
                  variant="light"
                  color={"blue"}
                  mt="sm"
                  radius="sm"
                  style={{ float: "right" }}
                  disabled={!selectedOrgId}

                  onClick={() => {
                    downloadFile(
                      `/api/FileUpload/GetFile?downloadId=${call.customFile?.id}`,
                      call.customFile?.name!
                    );
                  }}
                >
                  {t("pages.calls.download-file")}
                </Button>
              </Group>
            ) : (
              <></>
            )}
            {Date.now() > castToUnixTimestamp(call.openingAt!)! && call.enableUserDownloadPdf &&
            isSubmitted(call)  ? (
              <Group position="right" mb="xs">
                <AnswerPdf callId={call.id!} config={config}></AnswerPdf>
              </Group>
            ) : (
              <></>
            )}
          </Card>
        ))}

      {/*<Title order={1}>*/}
      {/*  {config.listName ?? t("pages.calls.list-open-rounds")}*/}
      {/*</Title>*/}
      <Divider my={25}></Divider>
      {calls
          ?.sort((a, b) => (a.name! > b.name! ? 1 : -1))
          .filter((call) => call.name != "" && call.name != null).filter((call) => isClosed(call))
          .map((call) => (
              <Card key={call.id} shadow="sm" p="md" radius="md" mb="md" withBorder>
                <Group position="apart" mb="xs">
                  <Text size="lg">{call.name}</Text>

                  <Text weight={400} color="dimmed">
                    {t("pages.calls.status") + " "}
                    {call.closingAt &&
                        (Date.now() < castToUnixTimestamp(call.closingAt)! &&
                        Date.now() > castToUnixTimestamp(call.openingAt)!
                            ? t("pages.calls.open")
                            : t("pages.calls.close"))}
                  </Text>
                </Group>

                <div dangerouslySetInnerHTML={{ __html: call.description! }}></div>

                <Divider mt="lg"></Divider>

                <Group position="right" mb="xs">
                  <Button
                      variant="light"
                      color={isClosed(call) ? "gray" : ( isSubmitted(call) ? "green" : "blue" )}
                      mt="sm"
                      radius="sm"
                      style={{ float: "right" }}
                      onClick={async () => await handleSubmission(call.id!, isClosed(call), call.submissionId)}
                      disabled={
                          orgs?.length == 0 ||
                          (isClosed(call) && !isSubmitted(call)) 
                              
                      }
                  >
                    {isSubmitted(call) 
                        ? t("pages.calls.closed")
                        : isClosed(call)
                                ? t("pages.calls.close") 
                                : hasStartedSubmission(call) 
                                    ? t("pages.calls.resume")
                                    : t("pages.calls.submit")    
                        // ?  ""
                        //    
                        // ? call.submissionId != "00000000-0000-0000-0000-000000000000"
                        //     ? call.submissionClosed
                        //         ? t("pages.calls.closed")
                        //         : call.submissionId !=
                        //         "00000000-0000-0000-0000-000000000000"
                        //             ? t("pages.calls.resume")
                        //             : t("pages.calls.submit")
                        //     : t("pages.calls.submit")
                        // : t("pages.calls.close")
                    }
                  </Button>
                </Group>
                {Date.now() > castToUnixTimestamp(call.openingAt!)! &&
                isSubmitted(call) &&
                call.userPowerBIReportID &&
                call.userPowerBIWorkspaceID ? (
                    <Group position="right" mb="xs">
                      <Button
                          variant="light"
                          color={"blue"}
                          mt="sm"
                          radius="sm"
                          style={{ float: "right" }}
                          onClick={async () =>
                              await handlePbi(
                                  call.userPowerBIReportID!,
                                  call.userPowerBIWorkspaceID!
                              )
                          }
                      >
                        {t("pages.calls.viewreport")}
                      </Button>
                    </Group>
                ) : (
                    <></>
                )}
                {Date.now() > castToUnixTimestamp(call.openingAt!)! &&
                isSubmitted(call) &&
                call.customFile ? (
                    <Group position="right" mb="xs">
                      <Button
                          variant="light"
                          color={"blue"}
                          mt="sm"
                          radius="sm"
                          style={{ float: "right" }}
                          onClick={() => {
                            downloadFile(
                                `/api/FileUpload/GetFile?downloadId=${call.customFile?.id}`,
                                call.customFile?.name!
                            );
                          }}
                      >
                        {t("pages.calls.download-file")}
                      </Button>
                    </Group>
                ) : (
                    <></>
                )}
                {Date.now() > castToUnixTimestamp(call.openingAt!)! && call.enableUserDownloadPdf &&
                isSubmitted(call)? (
                    <Group position="right" mb="xs">
                      <AnswerPdf callId={call.id!} config={config}></AnswerPdf>
                    </Group>
                ) : (
                    <></>
                )}
              </Card>
          ))}
    </>
  ) : null;
}

export default CallList;
